import { Grid, Typography } from '@mui/material'
import React from 'react'
import CircularProgress from '@mui/material/CircularProgress'

interface LoadingProps {
    size?: string | number | undefined
    text?: string
    color?:
        | 'primary'
        | 'secondary'
        | 'error'
        | 'info'
        | 'success'
        | 'warning'
        | 'inherit'
    height?: string | number
    direction?: 'row' | 'column'
    dataTestID?: string
}

function Loading({
    size = '3rem',
    color,
    height = '100%',
    direction = 'row',
    text,
    dataTestID,
}: LoadingProps) {
    return (
        <Grid
            style={{
                height,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                flexDirection: direction,
            }}
            data-testid={dataTestID}
            width={'100%'}
        >
            <CircularProgress color={color} size={size} />
            {text && (
                <Typography
                    sx={{
                        marginLeft: direction === 'row' ? '0.5rem' : undefined,
                        marginTop:
                            direction === 'column' ? '1.0rem' : undefined,
                    }}
                >
                    {text}
                </Typography>
            )}
        </Grid>
    )
}

export default Loading
